import React, { FunctionComponent } from 'react';
import {
  StyleSheet, Text, TouchableOpacity, View,
} from 'react-native';
import { TranslateProp } from '../../common-types';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  t: TranslateProp;
  onPress?: () => void;
  title: string;
  subTitle?: string;
  buttonTitle: string;
  disabled?: boolean;
}

const ConnectedItem: FunctionComponent<IProps> = (
  {
    t,
    onPress,
    title,
    subTitle,
    buttonTitle,
    disabled,
  },
) => {
  const isDisabled = disabled ?? !onPress;
  const textColor = () => {
    if (disabled) {
      return Theme.GREY_MEDIUM;
    }

    if (buttonTitle === t('installed')) {
      return Theme.GREEN;
    }

    return Theme.PRIMARY;
  };

  return (
    <View style={[styles.itemContainer]}>
      <View style={styles.iconLabelContainer}>
        <View>
          <Text style={styles.itemLabel}>
            {title}
          </Text>
          {subTitle && (
            <Text style={styles.subText}>
              {subTitle}
            </Text>
          )}
        </View>
      </View>
      <TouchableOpacity disabled={isDisabled} onPress={onPress}>
        <Text style={[styles.saveButton, { color: textColor() }]}>
          {buttonTitle}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  connectedItemsSubHeading: {
    marginBottom: defaultScale(20),
  },
  noTopBorder: {
    borderTopWidth: 0,
  },
  itemContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: defaultScale(20),
    borderColor: Theme.GREY_LIGHT,
    borderBottomWidth: 1,
  },
  itemLabel: {
    ...Theme.textStyle.bodyCopyReg,
    fontWeight: '400',
    color: Theme.CHARCOAL,
  },
  saveButton: {
    ...Theme.textStyle.bodyCopyBold,
    textAlign: 'center',
  },
  iconLabelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  subText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_MEDIUM_LIGHT,
  },
});

export default ConnectedItem;
